import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { environment } from '../../../environments/environment';

interface OneTrustWindow {
  OptanonWrapper: () => void;
}

@Injectable({ providedIn: 'root' })
export class OneTrustService {
  private readonly renderer: Renderer2 = inject(RendererFactory2).createRenderer(null, null);

  init(): void {
    this.loadScript(environment.oneTrustDomainScriptId);
    this.setupConsentHandler();
  }

  private loadScript(domainScriptId: string): void {
    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
    this.renderer.setAttribute(script, 'type', 'text/javascript');
    this.renderer.setAttribute(script, 'charset', 'UTF-8');
    this.renderer.setAttribute(script, 'data-domain-script', domainScriptId);
    this.renderer.appendChild(document.head, script);

    // Required stub — OneTrust calls this on every consent state change
    (globalThis as unknown as OneTrustWindow).OptanonWrapper = () => undefined;
  }

  private setupConsentHandler(): void {
    globalThis.addEventListener('OneTrustGroupsUpdated', (event: Event) => {
      const { detail } = event as CustomEvent<string[]>;
      if (detail.includes('C0002')) {
        this.enableGoogleAnalytics();
      } else {
        this.disableGoogleAnalytics();
      }
    });
  }

  private enableGoogleAnalytics(): void {
    const win = globalThis as unknown as Record<string, unknown>;
    delete win[`ga-disable-${environment.googleAnalyticsId}`];
  }

  private disableGoogleAnalytics(): void {
    // Google's official opt-out flag — stops GA from sending further hits
    // in the current session without requiring a page reload
    const win = globalThis as unknown as Record<string, unknown>;
    win[`ga-disable-${environment.googleAnalyticsId}`] = true;
  }
}
